<div class="scheduler-container">
    <div class="actions">
        <button mat-raised-button color="primary" (click)="addPatternEntry()">
            <mat-icon>add</mat-icon>
            Add Time Block
        </button>
    </div>
    <div class="scheduler-wrapper" #schedulerContainer></div>
</div>